import Cookies from 'js-cookie'
import {getCommonCode, getListSellingNotification, getListViewByUserID, revokeRefreshToken, searchAndPagingCountry} from './apis'
import { searchAndPagingCareer } from '../insurance/healthInsurance/apis'
import { SortArrayByParentCode } from '../../utils'
import { getConfig } from '../../../_metronic/i18n/Metronici18n'

const TokenUserInfoKey = 'UserInfo'

export function getUserInfo() {
  var info = Cookies.get(TokenUserInfoKey)
  if (info != undefined) {
    const userInfo = JSON.parse(info)
    return userInfo
  } else return null
}

export function getBasicAuthorization() {
  return 'Bearer ' + getToken()
}

export function getToken() {
  if (getUserInfo() == null) return ''
  else return getUserInfo().accessToken
}

export function getRefreshToken() {
  if (getUserInfo() == null) return ''
  else return getUserInfo().refreshToken
}

export function setUserInfo(info: string) {
  let date = new Date()
  date.setTime(date.getTime() + 2 * 60 * 60 * 1000)
  return Cookies.set(TokenUserInfoKey, info, {expires: date, sameSite: 'strict', secure: true})
}

export function removeDataLogin() {
  Cookies.remove('UserInfo')
  Cookies.remove('SessionId')
  localStorage.removeItem('category')
  localStorage.removeItem('user-approve')
  localStorage.removeItem('view:division')
  localStorage.removeItem('view:partner')
  localStorage.removeItem('persist:root')
  localStorage.removeItem('vehicleGroupsCode')
  localStorage.removeItem('motoGroupsCode')
  localStorage.removeItem('vehicleCarCompany')
  localStorage.removeItem('vehicleCarBrand')
  localStorage.removeItem('vehicleMotoCompany')
  localStorage.removeItem('vehicleMotoBrand')
  localStorage.removeItem('CommonCode')
  localStorage.removeItem('country')
  localStorage.removeItem('menu')
  localStorage.removeItem('career')
  localStorage.removeItem('provinces')
  localStorage.removeItem('districts')
  localStorage.removeItem('wards')
}

export function saveDataLocalStorage(res: any) {
  res.data.menus.map((o: any) => {
    if (o.childrens?.length == 0) delete o.childrens
    else {
      o.childrens?.map((o: any) => {
        o.hasBullet = true
        o.closeMenu = true
      })
    }
  })
  localStorage.setItem('menu', JSON.stringify(res.data.menus))
  localStorage.removeItem('view:division')
  localStorage.removeItem('view:partner')
  localStorage.removeItem('vehicleGroupsCode')
  localStorage.removeItem('motoGroupsCode')
  localStorage.removeItem('vehicleCarCompany')
  localStorage.removeItem('vehicleCarBrand')
  localStorage.removeItem('vehicleMotoCompany')
  localStorage.removeItem('vehicleMotoBrand')
  getListViewByUserID(res.data.userId).then((res: any) => {
    if (res && !res.isError) {
      if (res.result) {
        let partner: any = []
        let division: any = []
        let Default = {
          value: '0',
          label: 'Chọn',
        }
        partner.push(Default)
        division.push(Default)
        res.result.listDataViewPermissionApply.map((o: any) => {
          if (o.isChoosed) {
            o.value = o.objectReferenceCode
            o.label = o.objectReferenceName
            if (o.dataViewType == 2) division.push(o)
            if (o.dataViewType == 1) partner.push(o)
          }
        })
        localStorage.setItem('view:division', JSON.stringify(SortArrayByParentCode(division)))
        localStorage.setItem('view:partner', JSON.stringify(SortArrayByParentCode(partner)))
      }
    }
  }).catch((error) => {
    return
  })
  getCommonCode(getConfig().selectedLang).then((res: any) => {
    var program: any[] = []
    res.commonCode.map((o: any) => {
      let obj = {
        value: o.code,
        label: o.name,
        type: o.type,
      }
      program.push(obj)
    })
    program.sort((a, b) => a.type - b.type).sort((a, b) => a.value - b.value)
    localStorage.setItem('CommonCode', JSON.stringify(program))
  }).catch((error) => {
    return
  })
  searchAndPagingCountry().then((res: any) => {
    if(res && !res.isError) {
      res.result.items.forEach((elem: any) => {
        elem.value = elem.code
        elem.label = elem.name
      })
      localStorage.setItem('country', JSON.stringify(res.result.items))
    }
  }).catch((error) => {
    return
  })
  searchAndPagingCareer().then((res: any) => {
    if(res && !res.isError) {
      res.result.items.forEach((elem: any) => {
        elem.id = elem.id
        elem.value = elem.code
        elem.label = elem.name
        elem.isBlock = elem.isBlock
        elem.isRefer = elem.isRefer
      })
      localStorage.setItem('career', JSON.stringify(res.result.items))
    }
  }).catch((error) => {
    return
  })
}
